
export default class BaseBookingSave {
    constructor() {

        this.id = 0;
        this.jobNumber = ''
    }
}
